<div [ngClass]="[
		styles.thumbnail,
		cssClass ? cssClass : ''
	]" #bgThumbnail [style.height.px]="heightStyle" [style.width.px]="widthStyle" [style.backgroundSize]="bgSizeStyle" role="img" [attr.aria-label]="altTxt" vbImageLoad [bgImageUri]="bgImageUri">
</div>
